import "core-js/modules/es.array.reduce.js";
import _toConsumableArray from "/home/runner/work/housing-submarkets/housing-submarkets/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { array, stringValue } from 'vega-util';
import { STORE, TUPLE, unitName } from '.';
import { X, Y } from '../../channel';
import { warn } from '../../log';
import { hasContinuousDomain } from '../../scale';
import { keys } from '../../util';
import { assembleInit } from './assemble';
import { TUPLE_FIELDS } from './transforms/project';
import scales from './transforms/scales';
export var BRUSH = '_brush';
export var SCALE_TRIGGER = '_scale_trigger';
var interval = {
  signals: function signals(model, selCmpt) {
    var name = selCmpt.name;
    var fieldsSg = name + TUPLE_FIELDS;
    var hasScales = scales.has(selCmpt);
    var signals = [];
    var dataSignals = [];
    var scaleTriggers = [];

    if (selCmpt.translate && !hasScales) {
      var filterExpr = "!event.item || event.item.mark.name !== ".concat(stringValue(name + BRUSH));
      events(selCmpt, function (on, evt) {
        var _a;

        var filters = array((_a = evt.between[0].filter) !== null && _a !== void 0 ? _a : evt.between[0].filter = []);

        if (filters.indexOf(filterExpr) < 0) {
          filters.push(filterExpr);
        }

        return on;
      });
    }

    selCmpt.project.items.forEach(function (proj, i) {
      var channel = proj.channel;

      if (channel !== X && channel !== Y) {
        warn('Interval selections only support x and y encoding channels.');
        return;
      }

      var init = selCmpt.init ? selCmpt.init[i] : null;
      var cs = channelSignals(model, selCmpt, proj, init);
      var dname = proj.signals.data;
      var vname = proj.signals.visual;
      var scaleName = stringValue(model.scaleName(channel));
      var scaleType = model.getScaleComponent(channel).get('type');
      var toNum = hasContinuousDomain(scaleType) ? '+' : '';
      signals.push.apply(signals, _toConsumableArray(cs));
      dataSignals.push(dname);
      scaleTriggers.push({
        scaleName: model.scaleName(channel),
        expr: "(!isArray(".concat(dname, ") || ") + "(".concat(toNum, "invert(").concat(scaleName, ", ").concat(vname, ")[0] === ").concat(toNum).concat(dname, "[0] && ") + "".concat(toNum, "invert(").concat(scaleName, ", ").concat(vname, ")[1] === ").concat(toNum).concat(dname, "[1]))")
      });
    }); // Proxy scale reactions to ensure that an infinite loop doesn't occur
    // when an interval selection filter touches the scale.

    if (!hasScales) {
      signals.push({
        name: name + SCALE_TRIGGER,
        value: {},
        on: [{
          events: scaleTriggers.map(function (t) {
            return {
              scale: t.scaleName
            };
          }),
          update: scaleTriggers.map(function (t) {
            return t.expr;
          }).join(' && ') + " ? ".concat(name + SCALE_TRIGGER, " : {}")
        }]
      });
    } // Only add an interval to the store if it has valid data extents. Data extents
    // are set to null if pixel extents are equal to account for intervals over
    // ordinal/nominal domains which, when inverted, will still produce a valid datum.


    var init = selCmpt.init;
    var update = "unit: ".concat(unitName(model), ", fields: ").concat(fieldsSg, ", values");
    return signals.concat(Object.assign(Object.assign({
      name: name + TUPLE
    }, init ? {
      init: "{".concat(update, ": ").concat(assembleInit(init), "}")
    } : {}), {
      on: [{
        events: [{
          signal: dataSignals.join(' || ')
        }],
        update: dataSignals.join(' && ') + " ? {".concat(update, ": [").concat(dataSignals, "]} : null")
      }]
    }));
  },
  modifyExpr: function modifyExpr(model, selCmpt) {
    var tpl = selCmpt.name + TUPLE;
    return tpl + ', ' + (selCmpt.resolve === 'global' ? 'true' : "{unit: ".concat(unitName(model), "}"));
  },
  marks: function marks(model, selCmpt, _marks) {
    var name = selCmpt.name;
    var _selCmpt$project$hasC = selCmpt.project.hasChannel,
        x = _selCmpt$project$hasC.x,
        y = _selCmpt$project$hasC.y;
    var xvname = x && x.signals.visual;
    var yvname = y && y.signals.visual;
    var store = "data(".concat(stringValue(selCmpt.name + STORE), ")"); // Do not add a brush if we're binding to scales.

    if (scales.has(selCmpt)) {
      return _marks;
    }

    var update = {
      x: x !== undefined ? {
        signal: "".concat(xvname, "[0]")
      } : {
        value: 0
      },
      y: y !== undefined ? {
        signal: "".concat(yvname, "[0]")
      } : {
        value: 0
      },
      x2: x !== undefined ? {
        signal: "".concat(xvname, "[1]")
      } : {
        field: {
          group: 'width'
        }
      },
      y2: y !== undefined ? {
        signal: "".concat(yvname, "[1]")
      } : {
        field: {
          group: 'height'
        }
      }
    }; // If the selection is resolved to global, only a single interval is in
    // the store. Wrap brush mark's encodings with a production rule to test
    // this based on the `unit` property. Hide the brush mark if it corresponds
    // to a unit different from the one in the store.

    if (selCmpt.resolve === 'global') {
      var _iterator = _createForOfIteratorHelper(keys(update)),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var key = _step.value;
          update[key] = [Object.assign({
            test: "".concat(store, ".length && ").concat(store, "[0].unit === ").concat(unitName(model))
          }, update[key]), {
            value: 0
          }];
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    } // Two brush marks ensure that fill colors and other aesthetic choices do
    // not interefere with the core marks, but that the brushed region can still
    // be interacted with (e.g., dragging it around).


    var _a = selCmpt.mark,
        fill = _a.fill,
        fillOpacity = _a.fillOpacity,
        cursor = _a.cursor,
        stroke = __rest(_a, ["fill", "fillOpacity", "cursor"]);

    var vgStroke = keys(stroke).reduce(function (def, k) {
      def[k] = [{
        test: [x !== undefined && "".concat(xvname, "[0] !== ").concat(xvname, "[1]"), y !== undefined && "".concat(yvname, "[0] !== ").concat(yvname, "[1]")].filter(function (t) {
          return t;
        }).join(' && '),
        value: stroke[k]
      }, {
        value: null
      }];
      return def;
    }, {});
    return [{
      name: name + BRUSH + '_bg',
      type: 'rect',
      clip: true,
      encode: {
        enter: {
          fill: {
            value: fill
          },
          fillOpacity: {
            value: fillOpacity
          }
        },
        update: update
      }
    }].concat(_toConsumableArray(_marks), [{
      name: name + BRUSH,
      type: 'rect',
      clip: true,
      encode: {
        enter: Object.assign(Object.assign({}, cursor ? {
          cursor: {
            value: cursor
          }
        } : {}), {
          fill: {
            value: 'transparent'
          }
        }),
        update: Object.assign(Object.assign({}, update), vgStroke)
      }
    }]);
  }
};
export default interval;
/**
 * Returns the visual and data signals for an interval selection.
 */

function channelSignals(model, selCmpt, proj, init) {
  var channel = proj.channel;
  var vname = proj.signals.visual;
  var dname = proj.signals.data;
  var hasScales = scales.has(selCmpt);
  var scaleName = stringValue(model.scaleName(channel));
  var scale = model.getScaleComponent(channel);
  var scaleType = scale ? scale.get('type') : undefined;

  var scaled = function scaled(str) {
    return "scale(".concat(scaleName, ", ").concat(str, ")");
  };

  var size = model.getSizeSignalRef(channel === X ? 'width' : 'height').signal;
  var coord = "".concat(channel, "(unit)");
  var on = events(selCmpt, function (def, evt) {
    return [].concat(_toConsumableArray(def), [{
      events: evt.between[0],
      update: "[".concat(coord, ", ").concat(coord, "]")
    }, {
      events: evt,
      update: "[".concat(vname, "[0], clamp(").concat(coord, ", 0, ").concat(size, ")]")
    } // Brush End
    ]);
  }); // React to pan/zooms of continuous scales. Non-continuous scales
  // (band, point) cannot be pan/zoomed and any other changes
  // to their domains (e.g., filtering) should clear the brushes.

  on.push({
    events: {
      signal: selCmpt.name + SCALE_TRIGGER
    },
    update: hasContinuousDomain(scaleType) ? "[".concat(scaled("".concat(dname, "[0]")), ", ").concat(scaled("".concat(dname, "[1]")), "]") : "[0, 0]"
  });
  return hasScales ? [{
    name: dname,
    on: []
  }] : [Object.assign(Object.assign({
    name: vname
  }, init ? {
    init: assembleInit(init, true, scaled)
  } : {
    value: []
  }), {
    on: on
  }), Object.assign(Object.assign({
    name: dname
  }, init ? {
    init: assembleInit(init)
  } : {}), {
    on: [{
      events: {
        signal: vname
      },
      update: "".concat(vname, "[0] === ").concat(vname, "[1] ? null : invert(").concat(scaleName, ", ").concat(vname, ")")
    }]
  })];
}

function events(selCmpt, cb) {
  return selCmpt.events.reduce(function (on, evt) {
    if (!evt.between) {
      warn("".concat(evt, " is not an ordered event stream for interval selections."));
      return on;
    }

    return cb(on, evt);
  }, []);
}